import { SegmentedControl } from '@mantine/core'
import SegmentedControlClasses from './styles.module.css'
import '../../styles/variables.css'

export default SegmentedControl.extend({
    defaultProps: { radius: 'xl', size: 'xl' },
    classNames: SegmentedControlClasses,
})
